module.exports = __webpack_public_path__ + "img/map-big02.f9c98952.png";